<template>
  <div>
    <vx-card>
      <ListCongeners :subjectPermission="subjectPermission"></ListCongeners>
    </vx-card>
  </div>
</template>

<script>
import ListCongeners from './../../lists/ListCongeners';

export default {
  data() {
    return {
      subjectPermission: 'Perfil de Usuário',
    };
  },
  components: {
    ListCongeners,
  },
};
</script>
